import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export interface NewPlanParams {
  name: string;
  description: string | null;
  clientId: string;
}

const newPlan = (params: NewPlanParams): Promise<string> =>
  authFetch('/Consumer/ManagePlans/NewPlan', {
    method: 'POST',
    ...httpBodyOptions(params),
  });

export const useNewPlanMutation = () => {
  return useMutation(newPlan);
};
